<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>
    <table class="table table-bordered mb-0">
      <thead>
      <tr>
        <th>ID</th>
        <th>Warengruppe</th>
        <th>Startdatum</th>
        <th>Enddatum</th>
        <th>Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :key="item.id || 'new-' + index">
        <td>{{ item.id }}</td>
        <td>
          <select2 v-model="item.product_group" :disabled="!item.editing" :options="productGroupOptions"
                   placeholder="-- Warengruppe auswählen --" :settings="{width: '100%'}"></select2>
        </td>
        <td>
          <input v-model="item.valid_from" :disabled="!item.editing" class="form-control" type="date"/>
        </td>
        <td>
          <input v-model="item.valid_until" :disabled="!item.editing" class="form-control" type="date"/>
        </td>
        <td class="text-center">
          <button v-if="!item.editing" class="btn btn-outline btn-warning" type="button" @click="editItem(index)">
            <i class="fa fa-pencil"></i>
          </button>
          <button v-if="item.editing" :disabled="saving" class="btn btn-outline btn-primary" type="button"
                  @click="saveItem(index)">
            <i class="fa fa-check"></i>
          </button>
          <button :disabled="saving" class="btn btn-outline btn-danger" type="button"
                  @click="deleteItem(item.id, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <button class="btn btn-block btn-outline btn-info btn-sm" type="button" @click="addItem($event)">
      <i class="fa fa-plus"></i> Hinzufügen
    </button>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";

export default {
  name: "LoyaltySettingExclusionsProduct",
  components: {VueToastr},
  data() {
    return {
      items: [],
      productGroups: {},
      saving: false,
    };
  },
  computed: {
    productGroupOptions() {
      // Leading empty entry is required for the select2 placeholder.
      return [{id: "", text: ""}, ...Object.entries(this.productGroups).map(([value, label]) => ({id: value, text: label}))];
    }
  },
  props: {
    settingId: {
      type: [String, Number],
      required: true
    },
    clientId: {
      type: [String, Number],
      required: true
    },
    exclusionProduct: Object,
  },
  mounted() {
    this.fetchProductGroups();
    this.fetchExclusions();
  },
  methods: {
    async fetchProductGroups() {
      try {
        const response = await axios.get(`/backend/loyalty-program/settings/product-groups/${this.clientId}`);
        this.productGroups = response.data;
      } catch (error) {
        this.$refs.toast.e("Warengruppen konnten nicht geladen werden.", "Fehler");
      }
    },
    async fetchExclusions() {
      try {
        const response = await axios.get(`/backend/loyalty-program/settings/${this.settingId}/exclusion-products`);
        this.items = response.data.exclusionProducts.map(exclusion => ({
          id: exclusion.id,
          product_group: exclusion.product_group,
          valid_from: exclusion.valid_from || "",
          valid_until: exclusion.valid_until || "",
          editing: false
        }));
      } catch (error) {
        this.$refs.toast.e("Fehler beim Laden der Ausschlüsse.", "Fehler");
      }
    },
    addItem() {
      this.items.push({
        id: null,
        product_group: "",
        valid_from: "",
        valid_until: "",
        editing: true
      });
    },
    editItem(index) {
      this.items[index].editing = true;
    },
    async saveItem(index) {
      this.saving = true;
      const item = this.items[index];

      const payload = {
        id: item.id,
        loyalty_setting_id: this.settingId,
        product_group: item.product_group,
        valid_from: item.valid_from,
        valid_until: item.valid_until,
      };

      try {
        let response;
        if (item.id && item.id !== this.settingId) {
          const exclusionProductId = Number(item.id);
          response = await axios.put(`/backend/loyalty-program/settings/${this.settingId}/exclusion-products/${exclusionProductId}`, payload);
        } else {
          response = await axios.post(`/backend/loyalty-program/settings/${this.settingId}/exclusion-products`, payload);
          item.id = response.data.exclusionProduct.id;
        }
        item.editing = false;
        this.$refs.toast.s("Ausschluss nach Warengruppen erfolgreich gespeichert!", "Erfolg");
      } catch (error) {
        console.error(error.response?.data || error.message);
        this.$refs.toast.e("Fehler beim Speichern des Ausschluss nach Warengruppen.", "Fehler");
      } finally {
        this.saving = false;
      }
    },
    async deleteItem(id, index) {
      if (!id) {
        this.items.splice(index, 1);
        return;
      }

      if (!confirm("Möchten Sie diesen Ausschluss nach Warengruppen wirklich löschen?")) {
        return;
      }

      this.saving = true;
      try {
        await axios.delete(`/backend/loyalty-program/settings/${this.settingId}/exclusion-products/${id}`);
        this.items.splice(index, 1);
        this.$refs.toast.s("Ausschluss nach Warengruppen erfolgreich gelöscht!", "Erfolg");
      } catch (error) {
        this.$refs.toast.e("Fehler beim Löschen des Ausschluss nach Warengruppen.", "Fehler");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.table {
  margin-top: 20px;
}
</style>
